import { React, Container, Component, Link, _ } from 'utils';
import { LatestResumesStore as Store } from 'model';
import moment from 'moment/src/moment';
import {Config} from "../../utils";

const MAX_LENGTH = 50;

class LatestResumes extends Component {

	static getStores() {
		return [Store];
	}

	static calculateState() {
		return Store.getState();
	}

	title(value) {
		if(value.length > MAX_LENGTH) {
			return value.substr(0, MAX_LENGTH) + '...';
		} else {
			return value;
		}
	}

	render() {
		var { resumes } = this.state;

		if(resumes.length == 0) {
			return null;
		} else {
			var vResumes = resumes.map((item, index) => {
				return <div key={index} className="item">
					<div className="icon-panel">
						<i className="fa fa-file-o"></i>
						<div className="icon-body">
							<div className="published">{moment(item.date).format('DD.MM.YYYY HH:mm:ss')}h</div>
							<h5><Link to={Config.baseUrl+"resume/" + item.id }>{this.title(item.title)}</Link></h5>
						</div>
					</div>
				</div>
			});

			return <div className="latest-resumes">
				<h4>{_('Zadnje pregledani životopisi')}</h4>
				<div className="panel panel-default">
					<div className="items-box">
						{ vResumes }
					</div>
				</div>
			</div>
		}
	}
	
}

var container = Container.create(LatestResumes);
export default container;



// WEBPACK FOOTER //
// ./src/modules/app/resumes/LatestResumes.js